/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';

import ProfileModel from '../../models/ProfileModel';
import { ListItem, LocalizedListItem } from '../../apiServices/ListsService';
import { selectors as listSelectors } from '../redux/ducks/lists/lists';
import { withIntl } from '../../utilities/localizedUtil';

interface Props {
  intl?: any;
  countries?: ListItem[];
  states?: ListItem[];
  profile: ProfileModel;
}

@withIntl
@connect((state) => ({
  countries: listSelectors.getResidenceCountryCollection(state),
  states: listSelectors.getResidenceStateCollection(state),
}))
export class LocalizedResidence extends React.Component<Props, {}> {
  render() {
    const { profile, countries, states, intl } = this.props;

    const country = LocalizedListItem.wrap(countries, intl)
      .find(c => c.item.id === profile.residenceCountryId);

    if (!country) {
      return <span/>;
    }

    if (profile.residenceStateId) {
      const state = LocalizedListItem.wrap(states, intl)
        .find(s => s.item.id === profile.residenceStateId);

      return <span>{state.name}, {country.code}</span>;
    }

    return <span>{country.name}</span>;
  }
}
